import styled from 'styled-components';

export const StyledSpinnerLogo = styled.img`
  height: 110px;
`;
